import GlideCarousel from './glide_carousel'
import Carousel from '../../../../../lib/client_side_plugins/carousel'

export default {
  Carousel,
  GlideCarousel
}
